import styled from 'styled-components'

import { StyledH2 } from 'components/Typography/Headings'
import theme from 'theme_'

export const StyledMainHeading = styled(StyledH2)`
  margin: ${theme.spacing.xl} 0 ${theme.spacing.md};

  @media ${theme.devices.tablet} {
    margin-top: ${theme.spacing.xlarge};
  }

  @media ${theme.devices.desktop} {
    margin-top: ${theme.spacing.xl};
  }
`
